import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

import * as S from '../../styles';

import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import { FaCheck } from 'react-icons/fa';
import FieldFormik from '../../../../../../../../../components/newStudent/FieldFormik';
import { IDocumentsDegree } from '../../../../../../../../../types/newStudent/documents.interface';
import {
  INewStudentProvider,
  NewStudentProviderContext,
} from '../../../../../../../../../components/newStudent/ProviderNewStudent';
import { documentCertificate } from '../../../../../../../../../services/newStudent/documentStudent/document.service';
import {
  cleanCache,
  toCaptalize,
} from '../../../../../../../../../util/common/appUtil';
import { useTheme } from 'styled-components';
import {
  typeDocComplementary,
  typeDocInternship,
} from '../../../../../../../../../variables';
import {
  complementaryActivityTypeSelectOptions,
  internshipDocumentTypeSelectOptions,
} from '../../../../../../../../../constants/universityDegreePortfolio';

const defaultDataUniversity: IDocumentsDegree = {
  id: '',
  name: '',
  justification: '',
  startDate: '',
  endDate: '',
  workload: '',
  description: '',
  typeActivity: '',
  url: '',
  situation: 'aguardando',
};

interface Props {
  item: IDocumentsDegree;
  isOld?: boolean;
  setNewData?: Dispatch<SetStateAction<IDocumentsDegree[] | []>>;
  newData?: IDocumentsDegree[];
  setOldData?: Dispatch<SetStateAction<IDocumentsDegree[] | []>>;
  oldData?: IDocumentsDegree[];
  index: number;
  documentDegreeType: number;
  registrationId: number;
  universityDegreeId: number;
  degreeMetaComplete?: boolean;
}
export default function DegreeInput({
  item,
  isOld,
  setNewData,
  newData,
  registrationId,
  universityDegreeId,
  documentDegreeType,
  setOldData,
  oldData,
  degreeMetaComplete = false,
}: Props) {
  const theme = useTheme();
  const [dataItem, setDataItem] = useState(item);
  const { setIsLoading } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;

  const handlePickFile = (file: File) => {
    setDataItem((old) => ({ ...old, file: file, name: file.name }));
  };

  useEffect(() => {
    setDataItem(item);
  }, [item]);

  const fieldDisabled =
    degreeMetaComplete || (isOld === true && !!dataItem.checked);

  const handleSave = async () => {
    if (degreeMetaComplete) return;
    setIsLoading(true);
    try {
      const body = {
        id: String(dataItem.id),
        url: dataItem.url,
        file: dataItem.file,
        type: documentDegreeType,
        finalDate: dataItem.endDate,
        workload: +dataItem.workload,
        description: dataItem.description,
        initialDate: dataItem.startDate,
        registrationId: registrationId!,
        universityDegreeId: universityDegreeId!,
        typeActivity: dataItem.typeActivity,
      };
      const request = await documentCertificate.uploadCertificate({ body });
      if (request.result) {
        cleanCache('dataDocuments');
        let tmpData = dataItem;
        if (!isOld) {
          tmpData = {
            ...dataItem,
            id: request.data.id,
            url: request.data.url,
          };
        }
        const updateData = [...newData!, tmpData];
        setNewData && setNewData(updateData);
        setDataItem(defaultDataUniversity);
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (degreeMetaComplete) return;
    if (typeof item.id !== 'number') {
      const tmpData =
        newData?.filter((oldItem) => oldItem.id !== item.id) ?? [];
      setNewData && setNewData([...tmpData, defaultDataUniversity]);
      setDataItem(defaultDataUniversity);
    } else {
      try {
        setIsLoading(true);
        const body = {
          id: String(item.id),
          type: documentDegreeType,
          registrationId: registrationId!,
          universityDegreeId: universityDegreeId!,
        };
        const request = await documentCertificate.uploadCertificate({ body });
        if (request.result) {
          cleanCache('dataDocuments');
          if (!isOld) {
            const tmpData = newData?.filter(
              (oldItem) => oldItem.id !== item.id,
            ) ?? [defaultDataUniversity];
            setNewData && setNewData([...tmpData]);
            setDataItem(defaultDataUniversity);
          } else {
            const tmpData =
              oldData?.filter((oldItem) => +oldItem.id !== +item.id) ?? [];

            setOldData && setOldData(tmpData);
          }
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <S.Card className={'item_' + item.id}>
      <S.IconCard situation={dataItem.situation} />

      <S.CardSection width="10%">
        <S.Label>Situação</S.Label>
        <S.Text>{toCaptalize(dataItem.situation)}</S.Text>
      </S.CardSection>

      <S.CardSection width="40%">
        <S.Label>Descrição / Nome do Curso</S.Label>
        <FieldFormik
          name="description"
          align="start"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, description: target.value }))
          }
          disabled={fieldDisabled}
          type="string"
          value={dataItem.description}
          widthSize="fullWidth"
        />
      </S.CardSection>

      {documentDegreeType === +typeDocComplementary! && (
        <S.CardSection width="45%">
          <S.Label>Tipo de Atividade</S.Label>
          <FieldFormik
            name="typeActivity"
            align="start"
            onChange={({ target }) =>
              setDataItem((old) => ({ ...old, typeActivity: target.value }))
            }
            disabled={fieldDisabled}
            type="select"
            value={dataItem.typeActivity}
            widthSize="fullWidth"
            options={complementaryActivityTypeSelectOptions}
          />
        </S.CardSection>
      )}

      {documentDegreeType === +typeDocInternship! && (
        <S.CardSection width="45%">
          <S.Label>Tipo de documento do estágio</S.Label>
          <FieldFormik
            name="typeActivity"
            align="start"
            onChange={({ target }) =>
              setDataItem((old) => ({ ...old, typeActivity: target.value }))
            }
            disabled={fieldDisabled}
            type="select"
            value={dataItem.typeActivity}
            widthSize="fullWidth"
            options={internshipDocumentTypeSelectOptions}
          />
        </S.CardSection>
      )}

      <S.CardSection width="17%">
        <S.Label>Data Início</S.Label>
        <FieldFormik
          name="startDate"
          align="center"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, startDate: target.value }))
          }
          disabled={fieldDisabled}
          type="date"
          value={dataItem.startDate}
          widthSize={theme.size?.xxlarge ? 'small' : 'fullWidth'}
        />
      </S.CardSection>

      <S.CardSection width="17%">
        <S.Label>Data Fim</S.Label>
        <FieldFormik
          name="endDate"
          align="center"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, endDate: target.value }))
          }
          disabled={fieldDisabled}
          type="date"
          value={dataItem.endDate}
          widthSize={theme.size?.xxlarge ? 'small' : 'fullWidth'}
        />
      </S.CardSection>

      <S.CardSection width="11%">
        <S.Label>Carga Horária</S.Label>
        <FieldFormik
          name="workload"
          align="center"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, workload: target.value }))
          }
          disabled={fieldDisabled}
          type="number"
          value={dataItem.workload}
          widthSize="xsmall"
        />
      </S.CardSection>

      <S.CardSection width="50%">
        <S.Label>Arquivo</S.Label>
        <S.NameDiv>
          {!dataItem.file && !isOld ? (
            <S.InputFile>
              <S.InputText>Escolher arquivo</S.InputText>
              <input
                type="file"
                className="input-file"
                disabled={degreeMetaComplete}
                onChange={({ target }) => handlePickFile(target.files![0])}
              />
            </S.InputFile>
          ) : (
            <S.Text>{dataItem.name}</S.Text>
          )}

          <S.ButtonsDiv>
            {!isOld ? (
              !degreeMetaComplete &&
              !!dataItem.file && (
                <>
                  {JSON.stringify(item) !== JSON.stringify(dataItem) &&
                    dataItem.name && (
                      <S.ButtonSave onClick={() => handleSave()}>
                        <UploadFileIcon fontSize="large" />
                      </S.ButtonSave>
                    )}
                  <S.ButtonDelete onClick={() => handleDelete()}>
                    <DeleteForeverIcon fontSize="large" />
                  </S.ButtonDelete>
                </>
              )
            ) : degreeMetaComplete || dataItem.checked ? (
              <>
                {dataItem.url ? (
                  <S.ButtonDownload
                    href={dataItem.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <DownloadIcon fontSize="large" />
                  </S.ButtonDownload>
                ) : null}
                <FaCheck color={theme?.colors?.success} />
              </>
            ) : (
              <>
                <S.ButtonDownload
                  href={dataItem.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DownloadIcon fontSize="large" />
                </S.ButtonDownload>
                {JSON.stringify(item) !== JSON.stringify(dataItem) && (
                  <S.ButtonSave onClick={() => handleSave()}>
                    <UploadFileIcon fontSize="large" />
                  </S.ButtonSave>
                )}
                <S.ButtonDelete onClick={() => handleDelete()}>
                  <DeleteForeverIcon fontSize="large" />
                </S.ButtonDelete>
              </>
            )}
          </S.ButtonsDiv>
        </S.NameDiv>
      </S.CardSection>

      {dataItem.justification && (
        <S.CardSectionFullWidth>
          <S.Label>Justificativa</S.Label>
          <S.Text title={dataItem.justification}>
            {dataItem.justification}
          </S.Text>
        </S.CardSectionFullWidth>
      )}
    </S.Card>
  );
}
